export const formatPrice = (amount: number): string =>
  `${amount.toLocaleString('ko-KR')}원`;
